import PageTitle from 'components/common/PageTitle';
import React, { Component } from 'react';
import { connect } from 'react-redux';

class Reportes extends Component {

    render() {

        return (
            <div>
                <PageTitle 
                    title="sidebar.inventario.reportes"
                    className="plr-15"
                    breadCrumb={[
                    {
                        name: "sidebar.inventario"
                    },
                    {
                        name: "sidebar.inventario.reportes"
                    }
                    ]}
                />

                <div className="plr-15">
                    <div className="mtb-30 theme-color">
                        <div className="mtb-10">
                             Herramientas para manejo de reportes.
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        ...state.themeChanger
    };
}

export default connect(mapStateToProps, null)(Reportes);